export enum DashboardInfoTypeEnum {
  // ============================================
  // SUBSCRIPTION (Recurring/Assinaturas)
  // ============================================
  FUTURE_RELEASES_RECURRING = "FUTURE_RELEASES_RECURRING",
  TOTAL_TRANSACTIONS_RECURRING = "TOTAL_TRANSACTIONS_RECURRING",
  TRANSACTED_AMOUNT_RECURRING = "TRANSACTED_AMOUNT_RECURRING",
  AVERAGE_TICKET_RECURRING = "AVERAGE_TICKET_RECURRING",
  NOTIFICATIONS_RECURRING = "NOTIFICATIONS_RECURRING",
  VALUE_FEES_RECURRING = "VALUE_FEES_RECURRING",
  REFUSED_INSTALLMENTS_RECURRING = "REFUSED_INSTALLMENTS_RECURRING",
  RECEIVABLE_INSTALLMENTS_RECURRING = "RECEIVABLE_INSTALLMENTS_RECURRING",
  RECURRENCE_STATUS_RECURRING = "RECURRENCE_STATUS_RECURRING",
  INSTALLMENT_AMOUNT_RECURRING = "INSTALLMENT_AMOUNT_RECURRING",
  PAYMENT_STATUS_RECURRING = "PAYMENT_STATUS_RECURRING",

  // ============================================
  // ROTARY (Transações Avulsas)
  // ============================================
  TOTAL_TRANSACTIONS_ROTARY = "TOTAL_TRANSACTIONS_ROTARY",
  TRANSACTED_AMOUNT_ROTARY = "TRANSACTED_AMOUNT_ROTARY",
  AVERAGE_TICKET_ROTARY = "AVERAGE_TICKET_ROTARY",
}

export enum DashboardPaymentTypeEnum {
  // ============================================
  // SUBSCRIPTION (Recurring/Assinaturas)
  // ============================================
  PAYMENT_METHODS_RECURRING = "PAYMENT_METHODS_RECURRING",
  REASONS_REFUSAL_RECURRING = "REASONS_REFUSAL_RECURRING",
  APPROVAL_INDEX_GENERAL_RECURRING = "APPROVAL_INDEX_GENERAL_RECURRING",
  APPROVAL_INDEX_FIRST_INSTALLMENT = "APPROVAL_INDEX_FIRST_INSTALLMENT",
  APPROVAL_INDEX_OTHER_INSTALLMENTS = "APPROVAL_INDEX_OTHER_INSTALLMENTS",

  // ============================================
  // ROTARY (Transações Avulsas)
  // ============================================
  REASONS_REFUSAL_ROTARY = "REASONS_REFUSAL_ROTARY",
  PAYMENT_METHODS_ROTARY = "PAYMENT_METHODS_ROTARY",
  APPROVAL_INDEX_GENERAL_ROTARY = "APPROVAL_INDEX_GENERAL_ROTARY",
}

export enum DashboardSmaugTypeEnum {
  // ============================================
  // SUBSCRIPTION (Recurring/Assinaturas)
  // ============================================
  MOST_USED_BRAND_RECURRING = "MOST_USED_BRAND_RECURRING",
  VOLUME_DAY_WEEK_RECURRING = "VOLUME_DAY_WEEK_RECURRING",

  // ============================================
  // ROTARY (Transações Avulsas)
  // ============================================
  FUTURE_RELEASES_ROTARY = "FUTURE_RELEASES_ROTARY",
  MOST_USED_BRAND_ROTARY = "MOST_USED_BRAND_ROTARY",
  VOLUME_DAY_WEEK_ROTARY = "VOLUME_DAY_WEEK_ROTARY",
}
